import React from "react";
import firebird from "../../assets/images/firebird.png";
import {
  Backdrop,
  IconButton,
  InputAdornment,
  TextField,
  ThemeProvider,
} from "@mui/material";
import { useEffect, useState } from "react";
import { Link, useHistory } from "react-router-dom";
import { useFormik } from "formik";
import * as yup from "yup";
// import AccessLevel from "./AccessLevel";
import { createTheme } from "@mui/material/styles";

import { toast } from "react-toastify";

import Loader from "../../components/Loader";
import { useLocation } from "react-router-dom";
import axios from "axios";
import { xCheckSumIdGernator } from "../../helper/helper";
import VisibilityIcon from "@mui/icons-material/Visibility";
import VisibilityOffIcon from "@mui/icons-material/VisibilityOff";
import LockIcon from "@mui/icons-material/Lock";
import { ToastContainer } from "react-toastify";
import Swal from "sweetalert2";

export default function Updatepasswordd() {
  const theme = createTheme({
    components: {
      MuiInputLabel: {
        styleOverrides: {
          asterisk: {
            color: "red",
          },
        },
      },
    },
  });
  const [open, setOpen] = useState(false);
  const [verify, setVerify] = useState("");
  const [documents, setDocuments] = useState("");
  const [user, setUser] = useState("");
  const location = useLocation();
  const [showPassword3, setShowPassword3] = useState(false);
  const [showPassword2, setShowPassword2] = useState(false);

  // console.log(location);

  let split = location.search.split("=");
  split = split[1];

  const handleClickShowPassword3 = () => setShowPassword3(!showPassword3);
  const handleMouseDownPassword3 = () => setShowPassword3(!showPassword3);
  const handleClickShowPassword2 = () => setShowPassword2(!showPassword2);
  const handleMouseDownPassword2 = () => setShowPassword2(!showPassword2);

  const verifyTokenPassword = async () => {
    try {
      // console.log(split, "all user get byid");
      const xCheckSumValues = xCheckSumIdGernator(split);

      const res = await axios.post(
        `${process.env.REACT_APP_COMMON_API}/auth/v1/email/verification/`,
        {
          emailToken: split,
          requistId: xCheckSumValues.generator,
          isDebug: true,
        },
        {
          headers: {
            "X-CHECKSUM-ID": xCheckSumValues.allValuesHashed,
          },
        }
      );
      if (res.data.statusDescription.statusCode == 200) {
        setTimeout(() => {
          // toast.success({
          //   theme: "colored",
          // });
           Swal.fire({
          icon: "success",
          // title: "Oops...",
          text:  "Succcess",
          // footer: '<a href="">Why do I have this issue?</a>'
        });
        }, 200);
      } else {
        setTimeout(() => {
          // toast.error({
          //   theme: "colored",
          // });
          Swal.fire({
            icon: "error",
            // title: "Oops...",
            // text:  "Succcess",
            // footer: '<a href="">Why do I have this issue?</a>'
          });
        }, 200);
      }
    } catch (error) {
      // console.log(error);
      setTimeout(() => {
           Swal.fire({
        icon: "error",
        title: "Oops...",
        text: "Something went wrong",
        // footer: '<a href="">Why do I have this issue?</a>'
      });
      }, 200);
    }
  };

  // useEffect(() => {
  //   verifyTokenPassword();
  // }, []);

  const validationSchema = yup.object({
    newPassword: yup
      .string()
      .required("Please Enter your  password")
      .min(8)
      .max(40)
      .matches(
        /^(?=.*[A-Z])(?=.*[a-z])(?=.*\d)(?=.*[^A-Za-z0-9]).{8,}$/,
        "Must Contain at least 8 Characters, One Uppercase, One Lowercase, One Number and One Special Case Character"
      ),
    confirmPassword: yup
      .string()
      .oneOf([yup.ref("newPassword"), null], "Passwords must match"),
  });
  const formik = useFormik({
    initialValues: {
      newPassword: "",
      confirmPassword: "",
    },

    onReset: (initialValues) => ({
      values: { initialValues },
    }),
    validateOnChange: true,

    validationSchema: validationSchema,
    onSubmit: async (values) => {
      const Checksumvalues = xCheckSumIdGernator(
        localStorage.getItem("values")
      );

      try {
        setOpen(true);
        const res = await axios.post(
          `${process.env.REACT_APP_COMMON_API}/admin/v1/forget/user/password`,
          {
            msisdn: `${localStorage.getItem("values")}`,
            newPassword: values.newPassword,
            // userId: `${localStorage.getItem("userId")}`,
            requestId: Checksumvalues.generator,
            isDebug: false,
          },
          {
            headers: {
              "X-CHECKSUM-ID": Checksumvalues.allValuesHashed,
            },
          }
        );

        if (res.data.statusDescription.statusCode == 200) {
          setOpen(false);
          await setTimeout(async () => {
            // await toast.success(
            //   "Password Updated Successfully !! Please Login",
            //   {
            //     theme: "colored",
            //   }
            // );
              Swal.fire({
            icon: "success",
            title: "Oops...",
            text: "Password Updated Successfully !! Please Login",
            // footer: '<a href="">Why do I have this issue?</a>'
          });
          }, 100);
        } else {
          setOpen(false);
          await setTimeout(async () => {
             Swal.fire({
            icon: "error",
            title: "Oops...",
            text: res.data.statusDescription.description,
            // footer: '<a href="">Why do I have this issue?</a>'
          });
          }, 100);
        }
      } catch (error) {
        setOpen(false);
        // console.log(error, formik.errors, "formoik errores");
        await setTimeout(async () => {
              Swal.fire({
        icon: "error",
        title: "Oops...",
        text: "Something went wrong",
        // footer: '<a href="">Why do I have this issue?</a>'
      });
        }, 100);
      }
    },
  });
  return (
    <>
      <main class="main-content my-aut lgin_cntnt position-relative w-auto  border-radius-l  ">
        <Backdrop
          sx={{
            transform: "translateZ(0)",
            color: "#fff",
            zIndex: (theme) => theme.zIndex.drawer + 1,
          }}
          open={open}
          // onClick={handleClose}
        >
          <Loader />
        </Backdrop>
        <div class="container-fluid px-0">
          <ThemeProvider theme={theme}>
            <ToastContainer autoClose={5000} />
            <div class="row d-md-flex d-none h_vh align-items-cente mx-0">
              <div class="col-md-7 bg_18 d-flex">
                <div class="ps_8 my-auto py_5">
                  <img src={firebird} class="img-fluid d-block mx-auto" />
                  <p class="text-center m-0 mt-4">
                    FIREBIRD, An Omni Channel Solution which broadens
                    Communication channels to Telecom operators. Its an
                    integrated platform to meet the Business requirements with
                    respect to Messaging solutions and Voice solutions.
                  </p>
                </div>
              </div>
              <div
                class="col-md-5 d-flex align-items-center bg_8 p-4"
                style={{ padding: "3.5rem" }}
              >
                <div class="w-100">
                  <form onSubmit={formik.handleSubmit}>
                    <div class="" id="sign_in">
                      <div class="">
                        <div class="text-center">
                          <i class="fas fa-lock lock p-2"></i>
                        </div>
                        <div class="text-center mt-2">
                          <span class="d-inline-block text-capitalize">
                            {" "}
                            Change Password
                          </span>
                        </div>
                      </div>
                      <div class="my-4">
                        <div class="input-group input-group-outline input_field">
                          <div className="col-md-12 d-inline-flex">
                            <div className="me-2 mt-3">
                              <LockIcon style={{ fontSize: "17px" }} />
                            </div>
                            <TextField
                              required
                              className="w-100"
                              label="New Password"
                              color="primary"
                              size="small"
                              type={showPassword2 ? "text" : "password"}
                              name="newPassword"
                              variant="standard"
                              InputProps={{
                                endAdornment: (
                                  <InputAdornment position="end">
                                    <IconButton
                                      aria-label="toggle password visibility"
                                      onClick={handleClickShowPassword2}
                                      onMouseDown={handleMouseDownPassword2}
                                    >
                                      {showPassword2 ? (
                                        <VisibilityIcon
                                          sx={{ color: "#85CBF2" }}
                                        />
                                      ) : (
                                        <VisibilityOffIcon
                                          sx={{ color: "#85CBF2" }}
                                        />
                                      )}
                                    </IconButton>
                                  </InputAdornment>
                                ),
                              }}
                              value={formik.values.newPassword}
                              onChange={formik.handleChange}
                              error={
                                formik.touched.newPassword &&
                                Boolean(formik.errors.newPassword)
                              }
                              helperText={
                                formik.touched.newPassword &&
                                formik.errors.newPassword
                              }
                            />
                          </div>
                        </div>
                        <div class="input-group input-group-outline input_field mt-4">
                          <div className="col-md-12 d-inline-flex">
                            <div className="me-2 mt-3">
                              <LockIcon style={{ fontSize: "17px" }} />
                            </div>
                            <TextField
                              required
                              className="w-100"
                              label="Confirm Password"
                              color="primary"
                              size="small"
                              type={showPassword3 ? "text" : "password"}
                              name="confirmPassword"
                              variant="standard"
                              InputProps={{
                                endAdornment: (
                                  <InputAdornment position="end">
                                    <IconButton
                                      aria-label="toggle password visibility"
                                      onClick={handleClickShowPassword3}
                                      onMouseDown={handleMouseDownPassword3}
                                    >
                                      {showPassword3 ? (
                                        <VisibilityIcon
                                          sx={{ color: "#85CBF2" }}
                                        />
                                      ) : (
                                        <VisibilityOffIcon
                                          sx={{ color: "#85CBF2" }}
                                        />
                                      )}
                                    </IconButton>
                                  </InputAdornment>
                                ),
                              }}
                              value={formik.values.confirmPassword}
                              onChange={formik.handleChange}
                              error={
                                formik.touched.confirmPassword &&
                                Boolean(formik.errors.confirmPassword)
                              }
                              helperText={
                                formik.touched.confirmPassword &&
                                formik.errors.confirmPassword
                              }
                            />
                          </div>
                        </div>
                      </div>
                      <button
                        type="submit"
                        class="btn bg-gradient-primary register_grad d-block w-100 m-0"
                      >
                        Change
                      </button>
                      <div class="text-end mt-4 fw-bold" id="sign_up_in">
                        <Link to="/" class="text-capitalize">
                          Log in{" "}
                        </Link>
                      </div>
                    </div>
                  </form>
                </div>
              </div>
            </div>
          </ThemeProvider>
        </div>
      </main>
    </>
  );
}
